import css from '@emotion/css';
import React from 'react';
import styled from '@emotion/styled';
import { H3 } from 'ds/components/typography';

interface SectionProps {
  heading?: string;
  fancy?: boolean;
  withBottomMargin?: boolean;
  children: React.ReactNode;
  scrollId?: string;
}

const Root = styled.div<{ fancy: boolean; withBottomMargin: boolean }>`
  ${({ theme, withBottomMargin }) => css`
    color: ${theme.colors.neutrals.grey1};
    margin-bottom: ${withBottomMargin ? theme.spacing(7) : 0};

    > h3 {
      margin-bottom: ${theme.spacing(2)};
    }

    ${withBottomMargin && theme.media.showAt({ at: 1 })`
      margin-bottom: ${theme.spacing(6)};
    `}
  `}

  ${({ fancy, theme }) => fancy && css`
    border-radius: ${theme.borderRadius.tiny};
    border: 1px solid ${theme.colors.neutrals.grey8};
    padding: ${theme.spacing(3)};

    ${theme.media.showAt({ at: 1 })`
      padding: ${theme.spacing(3)} ${theme.spacing(2)};
    `}
  `}
`;

export const ScrollAnchor = styled.div`
  position: relative;
  top: ${({ theme }) => -theme.spacing(2)}px;
`;

const Section: React.FunctionComponent<SectionProps> = ({ heading, children, fancy, scrollId, withBottomMargin }) => (
  <Root withBottomMargin={withBottomMargin} fancy={fancy}>
    {scrollId ? <ScrollAnchor id={scrollId} /> : null}
    {heading ? <H3 weight="bold">{heading}</H3> : null}
    {children}
  </Root>
);

export default Section;
